import { Component } from '@angular/core';

@Component({
  selector: 'app-post-not-allowed',
  templateUrl: './post-not-allowed.component.html',
  styleUrls: ['./post-not-allowed.component.scss'],
})
export class PostNotAllowedComponent {}
